import { render, staticRenderFns } from "./GalleryItemsTable.vue?vue&type=template&id=30b2e4b3&scoped=true"
import script from "./GalleryItemsTable.vue?vue&type=script&lang=js"
export * from "./GalleryItemsTable.vue?vue&type=script&lang=js"
import style0 from "./GalleryItemsTable.vue?vue&type=style&index=0&id=30b2e4b3&prod&lang=less"
import style1 from "./GalleryItemsTable.vue?vue&type=style&index=1&id=30b2e4b3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_babel-core@7.0.0-bridge.0_@babel+core@7.25.8__cac_7uvw3tio4x4egbur7wz2ifovwa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b2e4b3",
  null
  
)

export default component.exports